// extracted by mini-css-extract-plugin
export default {"title":"styles_title__pjCq7","listItems":"styles_listItems__w+Kpf"};